import React, { PureComponent } from 'react';

class LedgerView extends PureComponent {
  render() {
    const {
      transactions,
      title,
      total,
      currency,
      removeTransaction,
    } = this.props;

    return (
      <div className="ledger-table-container">
        <h4>{title}</h4>
        <table>
          <thead>
          <tr className="header-row">
            <th>Date</th>
            <th>Account</th>
            <th>Debtor/Creditor</th>
            <th>Description</th>
            <th>Transaction #</th>
            <th>Amount</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          {transactions.map((transaction, i) => (
            <tr key={transaction._id} className={transaction.amount < 0 ? 'negative' : 'positive'}>
              <td>{transaction.date}</td>
              <td>{transaction.account}</td>
              <td>{transaction.target}</td>
              <td>{transaction.description}</td>
              <td className="transaction-number">{transaction.transactionNumber}</td>
              <td className="transaction-amount">
                {transaction.amount} {transaction.currency}
              </td>
              <td>
                <div className="action-buttons">
                  <button onClick={() => removeTransaction(transaction.transactionNumber)}><i className="fi-x size-18"></i> delete</button>
                </div>
              </td>
            </tr>
          ))}
          {total && (
            <tr className="totals">
              <td colSpan="5">Total:</td>
              <td colSpan="2">{Math.round(total * 100) / 100} {currency}</td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
    )
  }
}

export default LedgerView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/LedgerTable/LedgerTable.view.js